import api from "../store/services/api";

export const getWorkShifts = (params) =>
  api.get("/delivery-center/work-shifts/", { params });

export const createWorkShift = (workShift) =>
  api.post("/delivery-center/work-shifts/", workShift, {
    headers: { "Content-Type": "application/json" },
  });

export const editWorkShift = (workShift, workShiftId) =>
  api.put(`/delivery-center/work-shifts/${workShiftId}/`, workShift, {
    headers: { "Content-Type": "application/json" },
  });

export const deleteWorkShift = (workShiftId) =>
  api.delete(`/delivery-center/work-shifts/${workShiftId}/`);

const WorkShiftService = {
  getWorkShifts,
  createWorkShift,
  editWorkShift,
  deleteWorkShift,
};

export default WorkShiftService;
